"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Option = function Option() {
  return null;
};

var _default = Option;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-mentions/lib/Option.js
// module id = 1986
// module chunks = 0